import React from 'react';

interface FinalCTAProps {
  onNavigate: (path: string) => void;
}

const FinalCTA: React.FC<FinalCTAProps> = ({ onNavigate }) => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-r from-blue-600 to-purple-600">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
          Klaar om je WFT examen te halen?
        </h2>
        <p className="text-xl text-blue-100 mb-8">
          Sluit je aan bij 500+ studenten die al succesvol hun examen hebben gehaald
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button 
            onClick={() => onNavigate('/register')}
            className="bg-white text-blue-600 px-10 py-4 rounded-lg text-lg font-semibold hover:bg-blue-50 transform hover:scale-105 transition shadow-xl"
          >
            Start Nu Gratis →
          </button>
          <button 
            onClick={() => scrollToSection('pricing')}
            className="bg-blue-500 text-white px-10 py-4 rounded-lg text-lg font-semibold hover:bg-blue-400 transition border-2 border-white"
          >
            Bekijk Prijzen
          </button>
        </div>
        <p className="text-blue-100 text-sm mt-6">
          ✓ Geen creditcard nodig • ✓ 20 gratis AI vragen per maand • ✓ Direct beginnen
        </p>
      </div>
    </section>
  );
};

export default FinalCTA;